/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { JobsControllerRetriggerFileMutationResponse, JobsControllerRetriggerFilePathParams, JobsControllerRetriggerFile404 } from "../../models/jobsController/JobsControllerRetriggerFile";

function getJobsControllerRetriggerFileUrl(fileId: JobsControllerRetriggerFilePathParams["fileId"]) {
  const res = { method: 'POST', url: `/api/v1/jobs/retrigger-file/${fileId}` as const }  
  return res
}

/**
 * @description Cancels all existing jobs for the file and creates a fresh set of ingestion jobs. Use this to completely restart the processing workflow for a file.
 * @summary Re-trigger all jobs for a file
 * {@link /api/v1/jobs/retrigger-file/:fileId}
 */
export async function jobsControllerRetriggerFile(fileId: JobsControllerRetriggerFilePathParams["fileId"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<JobsControllerRetriggerFileMutationResponse, ResponseErrorConfig<JobsControllerRetriggerFile404>, unknown>({ method : "POST", url : getJobsControllerRetriggerFileUrl(fileId).url.toString(), ... requestConfig })  
  return res.data
}